export default "__VITE_ASSET__DiRexu_Z__"